import React from 'react';
import { useTranslation } from "react-i18next";
import { CommonPageUiLayer } from '../components/CommonPageUiLayer';
import { DrainageLeftMenuList } from '../utils/constants';

const Drainage_Drainage_Pumping_station = () => {
  const { t, i18n, ready } = useTranslation();

  return (

<CommonPageUiLayer leftNavsList={DrainageLeftMenuList} isLeftNavsListLong={true}> 
<div className="container">
            <div className="row">
              <div className="inner-title2 bas">
                <h3 className="fontSizeClass"> {t("List of Drainage Pumping Stations")} </h3>
              </div>
              <div className="mayor-table pump-list-tble">
                <table width="95%" border={0} align="center" cellPadding={2} cellSpacing={2}
                  className="table table-bordered officials">
                  <tbody>                    
                    <tr bgcolor="#302ba0" tabIndex={0} align="center" valign="middle">                     
                      <td className="text-white tble-brder-left">
                        {t("Sl. No")}.
                      </td>
                      <td className="text-white">
                        {t("Name of the Pumping Station")}
                      </td>
                      <td className="text-white">
                        {t("No of Pumps")}
                      </td>
                      <td className="text-white">
                        {t("Telephone No.")}
                      </td>
                      <td className="text-white tble-brder-right">
                        {t("Head of the department")}
                      </td>
                    </tr>

                    <tr>
                      <td>1</td>
                      <td><strong> {t("Maniktala Drainage PS")} </strong> </td>
                      <td>05</td>
                      <td>2350-1166</td>
                      <td> {t("Soumen Mukherjee Ex.Engr.(E) Mob : 9836305380")} </td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>{t("Belgachia")} </td>
                      <td>02</td>
                      <td>-</td>
                      <td> - </td>
                    </tr>

                    <tr>
                      <td>3a</td>
                      <td>{t("Beerpara(Old Station)")} </td>
                      <td>02</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>

                    <tr>
                      <td>3b</td>
                      <td>{t("Beerpara(New Station)")} </td>
                      <td>06</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>

                    <tr>
                      <td>4</td>
                      <td>{t("Ultadanga Siphon")} </td>
                      <td>01</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>

                    <tr>
                      <td>5</td>
                      <td>{t("Maniktala Siphon")} </td>
                      <td>01</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>{t("Marcus Square DPS")} </td>
                      <td>02</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>{t("PS-I (beside Ramkrishna Mahasasan)")} </td>
                      <td>04</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>{t("PS-II (KP Singh Road)")} </td>
                      <td>04</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>{t("PS-III (14/4, BT Road)")} </td>
                      <td>04</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>{t("Bangur MPS")} </td>
                      <td>05</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>11a</td>
                      <td>{t("Duttabagan(Old Station)")} </td>
                      <td> 06</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>11b</td>
                      <td>Duttabagan(New Station)</td>
                      <td> 06 </td>
                      <td> - </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>{t("Cossipore")} </td>
                      <td> 03 </td>
                      <td> - </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td>{t("R.K Ghosh Road")} </td>
                      <td> 03 </td>
                      <td> - </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>14</td>
                      <td>{t("Jagannath ghat")} </td>
                      <td> 04 </td>
                      <td> - </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>15</td>
                      <td> <strong> {t("Dhapa Lock Drainage PS")} </strong> </td>
                      <td> 09 </td>
                      <td> Dhapa Lock Drainage PS </td>
                      <td> {t("Biswajit Bala Ex. Engineer (M) Mob : 9433923082")} </td>
                    </tr>
                    <tr>
                      <td>16</td>
                      <td>{t("Topsia DPS")} </td>
                      <td> 07 </td>
                      <td> 2343-4236 </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>17</td>
                      <td>{t("Ultadanga DPS")} </td>
                      <td> 11 </td>
                      <td> 2359-4621 </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>18</td>
                      <td>{t("Kamdahari MPS ")} </td>
                      <td> 12 </td>
                      <td> - </td>
                      <td> -</td>
                    </tr>
                    <tr>
                      <td>19</td>
                      <td>{t("	Ultadanga Underpass PS")} </td>
                      <td>02 </td>
                      <td> - </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>20</td>
                      <td>{t("Ultadanga Storm PS")} </td>
                      <td> 03 </td>
                      <td> - </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>20</td>
                      <td>{t("Kamdahari")} </td>
                      <td> XI </td>
                      <td> 111 </td>
                      <td> {t("Purba Para, Kamdahari, Kolkata-84")} </td>
                    </tr>
                    <tr>
                      <td>21</td>
                      <td>{t("Patuli")} </td>
                      <td> 05 </td>
                      <td> - </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>22</td>
                      <td>{t("Maniktala Underpass ")} </td>
                      <td> 02 </td>
                      <td> - </td>
                      <td>- </td>
                    </tr>
                    <tr>
                      <td>23</td>
                      <td>{t("Hatisur")} </td>
                      <td> 05 </td>
                      <td> - </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>24</td>
                      <td>{t("Topsia Point 'A'")} </td>
                      <td> 07 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>25</td>
                      <td>{t("Chak Garia")} </td>
                      <td> 06 </td>
                      <td> - </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>26</td>
                      <td>{t("Baghajatin (PS1)")} </td>
                      <td> 03 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>27</td>
                      <td>{t("Jora Bridge (PS2)")} </td>
                      <td> 06 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>28</td>
                      <td>{t("Rajdanga (PS3)")} </td>
                      <td> 06 </td>
                      <td> - </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>29</td>
                      <td>{t("Nonadanga (PS4)")} </td>
                      <td> 06 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>30</td>
                      <td>{t("Ambedkar Bridge")} </td>
                      <td> 08 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>31</td>
                      <td>{t("Kasba")} </td>
                      <td> 05 </td>
                      <td> - </td>
                      <td>- </td>
                    </tr>
                    <tr>
                      <td>32</td>
                      <td>{t("EE-1 Minor")} </td>
                      <td> 06 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>33</td>
                      <td>{t("Chowlpatty")} </td>
                      <td> 05 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>34</td>
                      <td><strong> {t("Palmer Bridge Drainage PS")} </strong> </td>
                      <td> 13 </td>
                      <td> 2251-2402, 2251-0053 </td>
                      <td> {t("Biswanath Das Ex.Engr (M) Mob : 9830109712")} </td>
                    </tr>
                    <tr>
                      <td>35</td>
                      <td>{t("Thanthania")} </td>
                      <td> 02 </td>
                      <td> 2354-3748 </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>36</td>
                      <td>{t("LS-3 (Sirity)")} </td>
                      <td> 05 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>37</td>
                      <td>{t("	LS-2 (James Long Sarani)")} </td>
                      <td> 04 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>38</td>
                      <td>{t("Chingrighata")} </td>
                      <td> 07 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>39</td>
                      <td>{t("Pagladanga")} </td>
                      <td> 08 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>40</td>
                      <td>{t("Kuliatangra")} </td>
                      <td> 06 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>41</td>
                      <td>{t("Thakery Road")} </td>
                      <td> 05 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>42</td>
                      <td>{t("Sasisekhar")} </td>
                      <td> 05 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>43</td>
                      <td>{t("Hastings")} </td>
                      <td> 05 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>44</td>
                      <td>{t("Charu Avenue")} </td>
                      <td> 04 </td>
                      <td> - </td>
                      <td>- </td>
                    </tr>
                    <tr>
                      <td>45</td>
                      <td>{t("Tollygunge Golf Club")} </td>
                      <td> 04 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>46</td>
                      <td>{t("Naktala")} </td>
                      <td> 03 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>47</td>
                      <td>{t("Santinagar")} </td>
                      <td> 03 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>48a.</td>
                      <td><strong> {t("Ballygunge Drainage PS")} </strong> </td>
                      <td> 11 </td>
                      <td> 2344-9142 </td>
                      <td> {t("Swapan Pal Ex.Engr (E) Mob : 9433191165")} </td>
                    </tr>
                    <tr>
                      <td>48b.</td>
                      <td>{t("BDPS Deeper Sump")} </td>
                      <td> 08 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>49</td>
                      <td>{t("	Jodhpur Park DPS")} </td>
                      <td> 05 </td>
                      <td> 2483-8457 </td>
                      <td> - </td>
                    </tr>

                    <tr>
                      <td>50</td>
                      <td>{t("Mominpur")} </td>
                      <td> 08 </td>
                      <td> 2449-6630 </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>51</td>
                      <td>{t("Chetla Lock PS")} </td>
                      <td> 04 </td>
                      <td> 2400-6243 </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>52</td>
                      <td>{t("Nimakmahal PS")} </td>
                      <td> 02 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>53</td>
                      <td>{t("Kalighat DPS")} </td>
                      <td> 02 </td>
                      <td> 2439-8857 </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>54</td>
                      <td>{t("Southern Avenue")} </td>
                      <td> 04 </td>
                      <td> 2465-0408 </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>55</td>
                      <td>{t("Gokhel Road")} </td>
                      <td> 02 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>56</td>
                      <td>{t("LS-9 (Near Kantapukur Morgue)")} </td>
                      <td> 04 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>57</td>
                      <td>{t("LS-10 (Near Majherhat Bridge)")} </td>
                      <td> 03 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>58</td>
                      <td>{t("CPT Canal")} </td>
                      <td> 06 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>59</td>
                      <td>{t("Jinjira Bazar")} </td>
                      <td> 05 </td>
                      <td> - </td>
                      <td> {t("Sanjoy Halder Ex.(E) Mob : 9433203667")} </td>
                    </tr>
                    <tr>
                      <td>60a.</td>
                      <td>{t("	Santoshpur MPS")} </td>
                      <td> 05 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>60b,</td>
                      <td>{t("Santoshpur (New)")} </td>
                      <td> 06 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>61</td>
                      <td>{t("Trenching Grround")} </td>
                      <td> 03 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>62</td>
                      <td>{t("Dhankheti Khal")} </td>
                      <td> 05 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>63</td>
                      <td>{t("Sakuntala Park (Node C)")} </td>
                      <td> 06 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>64</td>
                      <td>{t("Behala Flying Club")} </td>
                      <td> 08 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>65</td>
                      <td>{t("Padirhati")} </td>
                      <td> 06 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>66</td>
                      <td>{t("New Monikhal,Akra Phatak")} </td>
                      <td> 08 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>67</td>
                      <td>{t("Begore Khal Ps")} </td>
                      <td> 09 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>68</td>
                      <td>{t("Joka Ps")} </td>
                      <td> 11 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>69</td>
                      <td><strong> {t("Kudghat L.S-5")} </strong> </td>
                      <td> 06 </td>
                      <td> - </td>
                      <td> {t("Supriyo Sengupta Ex.Engr (E) Mob : 9830311559")} </td>
                    </tr>
                    <tr>
                      <td>70</td>
                      <td>{t("Rathtala L.S-1A")} </td>
                      <td> 03 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>71</td>
                      <td>{t("Usha Gate L.S-1B")} </td>
                      <td> 03 </td>
                      <td> - </td>
                      <td>- </td>
                    </tr>
                    <tr>
                      <td>72</td>
                      <td>{t("Bashdroni L.S-2A ")} </td>
                      <td> 03 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>73</td>
                      <td>{t("Kalibari L.S-2B")} </td>
                      <td> 04 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>74</td>
                      <td>{t("Canal Road LS")} </td>
                      <td> 03 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>75</td>
                      <td>{t("Buroshibtala L.S-1")} </td>
                      <td> 04 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>
                    <tr>
                      <td>76</td>
                      <td>{t("Keorapukur MPS")} </td>
                      <td> 05 </td>
                      <td> - </td>
                      <td> - </td>
                    </tr>                 
                   
                  </tbody>
                </table>
                <div className="inner-title2 bas">
                  <h3 className="fontSizeClass"> {t("List of Sewage Treatment Plants")} </h3>
                </div>
                <table width="95%" border={0} align="center" cellPadding={2} cellSpacing={2}
                  className="table table-bordered officials">
                  <tbody>                    
                    <tr bgcolor="#302ba0" tabIndex={0} align="center" valign="middle">                     
                      <td className="text-white tble-brder-left">
                        {t("Sl. No")}.
                      </td>
                      <td className="text-white">
                        {t("Name of STP")}
                      </td>
                      <td className="text-white">
                        {t("Officer In-charge")}
                      </td>                     
                    </tr>

                    <tr>
                      <td>1</td>
                      <td>{t("Gardenreach STP")} </td>
                      <td> Sanjoy Halder,Ex.Engr(E) Mob: 9433203667</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>{t("SSE(Keorapukur) STP")} </td>
                      <td> Supriyo Sengupta,Ex.Engr(E) Mob: 9830311559 </td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>{t(" Bangur STP")} </td>
                      <td> Soumen Mukherjee,Ex.Engr(E) Mob: 9436305380 </td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>{t("Hatisur STP")} </td>
                      <td> Biswajit Bala,Ex.Engr(E) Mob: 9433923082 </td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>{t("Baghajatin STP")} </td>
                      <td> Biswajit Bala,Ex.Engr(E) Mob: 9433923082 </td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>             

            </div>
          </div>
          
</CommonPageUiLayer>

  )
}

export default Drainage_Drainage_Pumping_station